function PushService(sender_id) {
	var self = this;

	sender_id = sender_id || '224092471635';

	self.token = ko.observable();

	var getMessaging = () => new Promise((resolve, reject) => {
		if(!getMessaging.messaging) {
			if(!('firebase' in window)) return reject();
			firebase.initializeApp({
				messagingSenderId: sender_id
			});
			getMessaging.messaging = firebase.messaging();
		}
		resolve(getMessaging.messaging);
	});

	self.subscribe = function() {
		return getMessaging()
			.then(messaging => {
				return new Promise((resolve, reject) => {
					messaging.requestPermission()
						.then(function () {
							// получаем ID устройства
							messaging.getToken()
								.then(function (currentToken) {
									if(currentToken) {
										self.token(currentToken);
										resolve(currentToken);
									} else {
										console.warn('Не удалось получить токен.');
										self.token(null);
										reject(null);
									}
								})
								.catch(function (err) {
									console.warn('При получении токена произошла ошибка.', err);
									self.token(null);
									reject(null);
								});
						})
						.catch(function (err) {
							console.warn('Не удалось получить разрешение на показ уведомлений.', err);
							reject(null);
						});
				});
			})
	};

}

export default PushService;